import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Video, BookOpen, FileText, Award, HelpCircle, Database } from 'lucide-react';

const lmsModules = [
  { icon: BookOpen, title: 'Modules', desc: 'Structurer les formations en modules progressifs avec du contenu multimedia.' },
  { icon: Video, title: 'Lecons video', desc: 'Heberger et diffuser des formations video a la demande (type Udemy).' },
  { icon: FileText, title: 'Ressources', desc: 'Fournir des documents, presentations et materiels complementaires.' },
  { icon: Award, title: 'Certificats', desc: 'Generer automatiquement des certificats de completion personnalises.' },
  { icon: HelpCircle, title: 'Quiz', desc: 'Evaluer les connaissances avec des quiz interactifs et des examens.' },
  { icon: Database, title: 'Suivi de progression', desc: 'Suivre la progression des apprenants et generer des rapports.' },
];

const AcademyLMS = () => {
  return (
    <div className="p-6 lg:p-8" data-testid="academy-lms-admin">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <h1 className="font-heading text-2xl font-bold text-[#1D1D1B]">LMS - Plateforme d'apprentissage</h1>
          <Badge className="bg-[#F9B438]/20 text-[#F9B438]">En developpement</Badge>
        </div>
        <p className="text-neutral-500">Les modules d'apprentissage en ligne sont en cours de developpement. La structure de base est en place et prete pour l'activation future.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {lmsModules.map((mod, i) => (
          <Card key={i} className="opacity-75 hover:opacity-100 transition-opacity">
            <CardContent className="p-6 text-center">
              <div className="w-14 h-14 rounded-xl flex items-center justify-center mx-auto mb-4" style={{background:'linear-gradient(135deg, rgba(255,213,55,0.15) 0%, rgba(249,180,56,0.15) 100%)'}}>
                <mod.icon className="w-7 h-7 text-[#F9B438]" />
              </div>
              <h3 className="font-heading font-semibold text-[#1D1D1B] mb-2">{mod.title}</h3>
              <p className="text-sm text-neutral-500">{mod.desc}</p>
              <Badge variant="outline" className="mt-3 text-xs">Bientot disponible</Badge>
            </CardContent>
          </Card>
        ))}
      </div>
      <div className="mt-8 p-6 rounded-xl border-2 border-dashed border-neutral-200 text-center">
        <Database className="w-10 h-10 text-neutral-300 mx-auto mb-3" />
        <p className="text-neutral-500 text-sm">La structure de base de donnees LMS est prete. Les collections (courses, modules, lessons, videos, resources, enrollments, progress, certificates, quizzes) seront activees lors du deploiement de cette fonctionnalite.</p>
      </div>
    </div>
  );
};

export default AcademyLMS;
